export default {

    // AGENT AUTHENTICATION
    apiAgentLoginViaEmail(data) {
        return this.request(this.api().AGENT_LOGIN_WITH_CREDS, data)
            .exec().log()
            .mapresults((response) => {
                return new Promise((resolve, reject) => {
                    // Step 1: Get Agent Details
                    const headers = {
                        authorization: "Bearer " + response.access_token,
                    };

                    const getDetails = this.request(this.api().GET_AGENT_DETAILS, {}, headers).exec().get();
                    // const getStatus = this.request(this.api().GET_CONNECTOR_STATUS, {}, headers).exec().get();

                    // Step 2: Wait for both promises
                    Promise.all([getDetails])
                        .then(([details, status]) => {
                            console.log("user details", details);
                            console.log("user status", status);

                            let retdata = {
                                auth: response.access_token,
                                logged: {
                                    ...Object.except(data, ["password"]),
                                    ...response,
                                },
                                user: {
                                    ...details,
                                    ...status,
                                    refresh: response.refresh_token,
                                },
                            };

                            resolve(retdata);
                            return retdata;
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            })
            .get();
    },

    apiAgentPasswordReset(data) {
        return this.request(this.api().AGENT_PASSWORD_RESET, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiAgentPasswordGenerate(urldata = {}) {
        return this.request(this.api().AGENT_GENERATE_TEMPORARY_PASSWORD)
            .urltransform(urldata)
            .exec().log().mapresults((res) => {
                return res.data
            }).get();
    },

    apiAgentLoginRequestViaOtp(data) {
        return this.request(this.api().AGENT_LOGIN_REQUEST_VIA_OTP, data)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiAgentLoginVerifyViaOtp(data) {
        return this.request(this.api().AGENT_LOGIN_VERIFY_VIA_OTP, data)
            .exec()
            .log()
            .mapresults((response) => {
                return new Promise((resolve, reject) => {
                    // Step 1: Get Agent Details
                    const headers = {
                        authorization: "Bearer " + response.access_token,
                    };

                    const getDetails = this.request(this.api().GET_AGENT_DETAILS, {}, headers).exec().get();
                    // const getStatus = this.request(this.api().GET_CONNECTOR_STATUS, {}, headers).exec().get();

                    // Step 2: Wait for both promises
                    Promise.all([getDetails])
                        .then(([details, status]) => {
                            console.log("user details", details);
                            console.log("user status", status);

                            let retdata = {
                                auth: response.access_token,
                                logged: {
                                    ...Object.except(data, ["password"]),
                                    ...response,
                                },
                                user: {
                                    ...details,
                                    ...status,
                                    role: "AGENT",
                                    refresh: response.refresh_token,
                                },
                            };

                            resolve(retdata);
                            return retdata;
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            })
            .get();
    },

    // AGENT
    apiAddAgent(data) {
        return this.request(this.api().ADD_AGENT, data).exec().log().get();
    },

    apiGetAgents(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_AGENTS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiGetAgentById(urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().GET_AGENT_BY_ID,)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((res) => {
                return res
            })
            .get();
    },

    apiUpdateAgent(data, urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };

        return this.request(this.api().UPDATE_AGENT, data).urltransform(urldata).exec().log().get();
    },

    apiDeleteAgent(urldata = mixins.params()) {

        return this.request(this.api().DELETE_AGENT)
            .urltransform(urldata)
            .exec().log().get();
    },

    // AGENT APPLICATION
    apiAddAgentApplication(data) {
        return this.request(this.api().ADD_AGENT_APPLICATION, data).exec().log().get();
    },

    apiGetAgentApplications(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_AGENT_APPLICATIONS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiGetAgentApplicationById(urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().GET_AGENT_APPLICATION_BY_ID,)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((res) => {
                return res
            })
            .get();
    },

    apiUpdateAgentApplication(data, urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };

        return this.request(this.api().UPDATE_AGENT_APPLICATION, data).urltransform(urldata).exec().log().get();
    },

    apiDeleteAgentApplication(urldata = mixins.params()) {

        return this.request(this.api().DELETE_AGENT_APPLICATION)
            .urltransform(urldata)
            .exec().log().get();
    },
}